export function EditMember(props) {
    const member = props.member;

    if (!member) {
        alert("Учасника не знайдено!")
        return null;
    }

    return (
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: '#e0e7ff',
            color: '#4338ca',
            padding: '0px 10px',
            borderRadius: '16px',
            margin: '4px',
            fontSize: '14px',
            fontWeight: '500',
            border: '1px solid #c7d2fe'
        }}>
            <span style={{ marginRight: '8px' }}>{member.nickName}</span>
            <button
                onClick={() => props.onDeleteClicked(member)}
                title="Видалити учасника"
                style={{
                    border: 'none',
                    background: 'none',
                    color: '#ef4444',
                    cursor: 'pointer',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    padding: '0 2px',
                    lineHeight: '1'
                }}
            >
                ×
            </button>
        </div>
    );
}